import { TFilters } from '../ecp-filters-modal.models';

export const isFilterStateDefault = (state: TFilters) => {
  const { services, shops, specializations } = state;
  return !services && !shops.length && !specializations.length;
};
